export enum ShareAction {
  'Download',
  'AddToMyfiles',
}
